

function initialState() {
    return {
        dataTableItems: [],
        fullSearchResponse : {},
        item: [],
        items: [],
        columnDefinitions: [],
        itemsLoading: false
    }
}



export default {
    state: initialState(),
    getters: {

        ITEMS: state => {
            return state.items
        },
    },
    mutations: {

        SET_PROGRESS_LOADING(state, payload) {
            state.itemsLoading = payload;
        },
        RESET(state) {
            const s = initialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        },
    },
    actions: {

        RESET: (context, payload) => {
            context.commit('RESET', payload);
        },

    }
}
